export function Card({ className = "", children, ...p }) {
  return (
    <div className={`rounded-2xl border border-slate-100 bg-white shadow-[0_2px_15px_rgb(0,0,0,0.02)] transition-shadow duration-300 ${className}`} {...p}>
      {children}
    </div>
  );
}

export function Btn({ variant = "primary", className = "", ...p }) {
  const styles = {
    primary: "bg-[#0b1220] text-white hover:bg-[#1a2438] hover:shadow-lg hover:shadow-slate-900/10 hover:-translate-y-0.5",
    ghost: "bg-transparent hover:bg-slate-100 text-slate-700",
    outline: "border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 hover:-translate-y-0.5",
  };
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium transition-[background-color,box-shadow,transform] duration-200 active:scale-[.98] disabled:opacity-50 disabled:hover:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0b1220]/20 focus-visible:ring-offset-1 ${styles[variant]} ${className}`}
      {...p}
    />
  );
}

export function Input({ className = "", ...p }) {
  return (
    <input
      className={`w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 transition-[border-color,box-shadow] duration-200 focus:outline-none focus:border-[#0b1220]/40 focus:ring-4 focus:ring-[#0b1220]/5 ${className}`}
      {...p}
    />
  );
}

export function Badge({ tone = "muted", children }) {
  const tones = {
    muted: "bg-slate-100 text-slate-600",
    pos: "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200/70",
    neg: "bg-red-50 text-red-700 ring-1 ring-red-200/70",
    warn: "bg-amber-50 text-amber-700 ring-1 ring-amber-200/70",
    primary: "bg-slate-900/[0.04] text-slate-700 ring-1 ring-slate-900/[0.06]",
  };
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${tones[tone]}`}>
      {children}
    </span>
  );
}

export function TabBar({ tabs, active, onChange }) {
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-slate-200/80 bg-white/70 p-1 backdrop-blur-sm" data-testid="tabbar">
      {tabs.map((tb) => (
        <button key={tb.key} data-testid={`tab-${tb.key}`} onClick={() => onChange(tb.key)}
          className={`flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-medium transition-[background-color,color] duration-200 ${active === tb.key ? "bg-[#0b1220] text-white shadow-sm" : "text-slate-500 hover:text-slate-900"}`}>
          {tb.icon && <tb.icon size={15} strokeWidth={1.75} />} {tb.label}
        </button>
      ))}
    </div>
  );
}

export const fmtBRL = (v) =>
  "R$ " + Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: 0 });

import { useState } from "react";
import { FileSpreadsheet, FileText as FileTextIcon, Loader2 } from "lucide-react";
import { download, apiErr } from "@/lib/api";
import { toast } from "sonner";

export function ExportButtons({ basePath, name, testid = "export" }) {
  const [busy, setBusy] = useState("");
  const run = async (fmt) => {
    setBusy(fmt);
    try {
      await download(`${basePath}?format=${fmt}`, `${name}.${fmt}`);
      toast.success(`Exportação ${fmt.toUpperCase()} concluída`);
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setBusy("");
    }
  };
  return (
    <div className="inline-flex items-center gap-2">
      <Btn variant="outline" className="px-3.5 py-2" disabled={!!busy}
        onClick={() => run("csv")} data-testid={`${testid}-csv`}>
        {busy === "csv" ? <Loader2 size={15} className="animate-spin" /> : <FileSpreadsheet size={15} strokeWidth={1.75} />} CSV
      </Btn>
      <Btn variant="outline" className="px-3.5 py-2" disabled={!!busy}
        onClick={() => run("pdf")} data-testid={`${testid}-pdf`}>
        {busy === "pdf" ? <Loader2 size={15} className="animate-spin" /> : <FileTextIcon size={15} strokeWidth={1.75} />} PDF
      </Btn>
    </div>
  );
}
